// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__jiH7I","boxTitle":"Qualiphy_boxTitle__2G_FQ","box":"Qualiphy_box__3zYwB","toggleWrap":"Qualiphy_toggleWrap__J3Orl"};